import { AxiosInstance } from "axios";

import { ChatInboxItemI } from "@/api/routes/messaging";
import { DashboardNotificationI } from "@/lib/types/notification";
import { LeaderboardItemI } from "@/lib/types/leaderboards";
import { CampaignV3I } from "@/lib/types/campaign";

export interface DashboardActivityCallI {
  title: string;
  subtitle: string;
  account_id?: string;
  campaign_name: string;
  campaign_id?: string;
  timestamp: string;
}

export interface GetDashboardActivityResponseI {
  calls: DashboardActivityCallI[];
  messages: ChatInboxItemI[];
  certifications: DashboardNotificationI[];
}

export interface GetDashboardUserStatsResponseI {
  qualified_meetings_booked: number;
  hours_spent_on_campaign: number;
  calls_made: number;
  show_up_rate: number;
  total_earnings_in_usd: number;
}

export interface GetDashboardLeaderboardResponseI {
  leaderboard: Array<LeaderboardItemI>;
  my_standing: LeaderboardItemI;
  start_date: string;
  end_date: string;
}

export interface GetDashboardCampaignsResponseI {
  campaigns: Array<CampaignV3I>;
}

interface WeeklyMetricI {
  current_week: number;
  previous_week: number;
}

export interface DashboardMetricsI {
  booked_meetings: WeeklyMetricI;
  cancels: WeeklyMetricI;
  conversations: WeeklyMetricI;
  convo_right_icp: WeeklyMetricI;
  pickups: WeeklyMetricI;
  pre_qualified_meetings: WeeklyMetricI;
  qualified_meetings: WeeklyMetricI;
  reschedules: WeeklyMetricI;
  show_not_qualified: WeeklyMetricI;
  time_on_dialer: WeeklyMetricI;
}

export interface GetDashboardMetricsResponseI {
  all_time_pre_qualified_meetings: number;
  metrics: DashboardMetricsI;
}

export const UserDashboardAPIEndpoints = (API: AxiosInstance) => ({
  getDashboardCampaigns: () =>
    API.get<GetDashboardCampaignsResponseI>(
      "/v1/dashboard/campaign_highlights"
    ),
  getDashboardUserStats: () =>
    API.get<GetDashboardUserStatsResponseI>("/v1/dashboard/my_stats"),
  getDashboardLeaderboard: () =>
    API.get<GetDashboardLeaderboardResponseI>("/v1/dashboard/leaderboard"),
  getDashboardMetrics: () =>
    API.get<GetDashboardMetricsResponseI>("/v1/dashboard/metrics"),
});
